/**
 * ActorAvatar (Story 34.5) — initials circle derived from an actor email.
 * Deterministic color from the email hash (mirrors ClientAvatar's approach).
 */

import { cn } from "@provenleap/ui";

const AVATAR_COLORS = [
  "#FF6D6F",
  "#4F46E5",
  "#059669",
  "#D97706",
  "#7C3AED",
  "#DB2777",
  "#0891B2",
  "#65A30D",
  "#DC2626",
  "#2563EB",
];

function hashColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]!;
}

/** First letter of the local part; "S" for system / null actors. */
export function actorInitials(email: string | null | undefined): string {
  const safe = (email ?? "").trim();
  if (!safe) return "S";
  return safe.charAt(0).toUpperCase();
}

export function ActorAvatar({
  email,
  className,
}: {
  email: string | null | undefined;
  className?: string;
}) {
  const seed = email ?? "system";
  const initials = actorInitials(email);
  return (
    <span
      data-testid="actor-avatar"
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full text-[12px] font-semibold text-white",
        "h-9 w-9",
        className
      )}
      style={{ backgroundColor: hashColor(seed) }}
      aria-hidden="true"
    >
      {initials}
    </span>
  );
}
